<div class="flex flex-col gap-2">
  @for (
    notification of notifications.notifications$ | async;
    track notification.uid
  ) {
    <pr-popup-notification [notification]="notification" />
  }
  @if (notifications.hasMultipleNotifications$ | async) {
    <button mat-flat-button (click)="clearAll()">
      <mat-icon>clear_all</mat-icon>
      Clear All
    </button>
  }
</div>
